import React, { useEffect, useState } from "react";
import { onAuthStateChanged, getAuth, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc, collection, getDocs, query, where } from "firebase/firestore";
import { app } from "../firebase";
import { useNavigate } from "react-router-dom";
import LoadingComLayout from "../components/LoadingComLayout";
import BarbeiroPainel from "./BarbeiroPainel";
import ProprietarioPainel from "./ProprietarioPainel";
import PainelLayout from "../components/PainelLayout"; // Importando o Layout aqui

const auth = getAuth(app);
const db = getFirestore(app);

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [painel, setPainel] = useState(null); // 'barbeiro' | 'proprietario' | null
  const navigate = useNavigate();

  useEffect(() => {
    // Flag para evitar atualizações de estado em componente desmontado
    console.log("Home: Iniciando verificação de autenticação e perfil...");
    let isMounted = true;

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!isMounted) return;

      // 1. SEM USUÁRIO -> LOGIN
      if (!currentUser) {
        console.log("Home: Ninguém logado. Redirecionando...");
        if (isMounted) navigate("/login");
        return;
      }

      const uid = currentUser.uid;
      console.log("Home: Usuário detectado, verificando...", uid);

      try {
        // ---------------------------------------------------------
        // 2. VERIFICA SE É PROPRIETÁRIO
        // ---------------------------------------------------------
        const q = query(collection(db, "barbearia"), where("criadorUid", "==", uid));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty && isMounted) {
          console.log("Home: É proprietário.");
          setPainel("proprietario");
          setLoading(false);
          return;
        }

        // ---------------------------------------------------------
        // 3. VERIFICA SE É BARBEIRO
        // ---------------------------------------------------------
        const barbeariasSnapshot = await getDocs(collection(db, "barbearia"));
        
        let encontrouBarbeiro = false;

        for (const docBarbearia of barbeariasSnapshot.docs) {
          const barbeiroRef = doc(db, `barbearia/${docBarbearia.id}/barbeiros/${uid}`);
          const barbeiroSnap = await getDoc(barbeiroRef);

          if (barbeiroSnap.exists()) {
            const data = barbeiroSnap.data();
            if (data.cargo === "barbeiro" || data.cargo === "admin") {
              if (isMounted) {
                console.log("Home: É barbeiro.");
                setPainel("barbeiro");
                setLoading(false);
              }
              encontrouBarbeiro = true;
              return;
            }
          }
        }

        // ---------------------------------------------------------
        // 4. NÃO É NADA -> LOGIN
        // ---------------------------------------------------------
        if (!encontrouBarbeiro && isMounted) {
          console.warn("Home: Usuário sem perfil.");
          await signOut(auth);
          navigate("/login");
        }

      } catch (error) {
        console.error("Home: Erro ao verificar perfil:", error);
        if (isMounted) {
           await signOut(auth);
           navigate("/login");
        }
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [navigate]);

  if (loading) return <LoadingComLayout />;

  // AQUI É O TRUQUE: 
  // Como tiramos a Home de dentro do PainelLayout no App.js,
  // precisamos envelopar o conteúdo aqui.
  // Isso garante que o Layout só apareça DEPOIS que sabemos quem é o usuário.
  return (
    <>
        {painel === "proprietario" && <ProprietarioPainel />}
        {painel === "barbeiro" && <BarbeiroPainel />}
    </>
  );
}